module.exports = __webpack_public_path__ + "img/card4.14e45676.png";